import '@/assets/sass/argon.scss';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import GlobalComponents from './plugins/globalComponents';

import './registerServiceWorker'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './plugins/axios'
import './plugins/slimdialog'
import './plugins/vuemask'
import './plugins/vuemodal'

Vue.config.productionTip = false;

Vue.use(GlobalComponents);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
